module.exports = __webpack_public_path__ + "media/images/logo-rema-blue-616cea9b1961a80d446b17211b0698be.svg";